import ExpandableSearch from "components/atoms/ExpandableSearch/ExpandableSearch";
import React, { useMemo, useState } from "react";
import { InputGroup } from "react-bootstrap";

type MultiSelectFilterProps = {
  options?: Record<string, any>[];
  searchable?: boolean;
  currentFilters: Record<string, any>;
  setFilters: Function;
  filterKey: string;
  eventContext: string; // eslint-disable-line react/no-unused-prop-types
};

function MultiSelectFilter(props: MultiSelectFilterProps) {
  const { options, currentFilters, setFilters, filterKey, searchable } = props;
  const [searchText, setSearchText] = useState("");

  const filteredOptions = useMemo(() => {
    if (searchText?.trim()?.length) {
      return options?.filter((option) => option.label.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()));
    }
    return options;
  }, [searchText, options]);

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>, currentOption: any) => {
    if (e.target.checked) {
      setFilters({
        ...currentFilters,
        [filterKey]: Array.isArray(currentFilters[filterKey])
          ? [...currentFilters[filterKey], currentOption.value]
          : [currentOption.value],
      });
    } else {
      setFilters({
        ...currentFilters,
        [filterKey]: currentFilters[filterKey].filter((item: any) => item !== currentOption.value),
      });
    }
  };

  return (
    <div className="multiselect-filter">
      {searchable && (
        <ExpandableSearch
          containerClasses="mb-3"
          alwaysExpanded
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      )}
      {filteredOptions?.map((item, index) => (
        <div className="mb-10" key={index}>
          <InputGroup className="checkbox bg-transparent mb-1">
            <label htmlFor={item.label} className="d-flex align-items-center cursor-pointer mb-0 w-100">
              <input
                id={item.label}
                type="checkbox"
                className="d-none"
                onChange={(e) => handleSelect(e, item)}
                checked={!!currentFilters[filterKey]?.includes(item.value)}
              />
              <span className="border-dark border-solid border-1 mr-2 position-relative br-3 checkbox__box" />
              <span className="font-b3 mr-auto">{item.label}</span>
            </label>
          </InputGroup>
        </div>
      ))}
    </div>
  );
}

export default MultiSelectFilter;

MultiSelectFilter.defaultProps = {
  options: [],
  searchable: false,
};
